const styles = (theme) => ({
  storesList: {
    maxHeight: '65vh',
    overflow: 'auto',
  },
  faceWidget: {
    lineHeight: 0,
  },
  faceWidgetInHeader: {
    lineHeight: 2,
    color: theme.color.black,
    fontSize: 20,
    marginLeft: 5,
  },
  filterItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    color: theme.color.black,
    padding: theme.spacing(2, 2.5),

    '&:hover, &:active': {
      backgroundColor: theme.color.grey_ed,
    },
  },
  chevronIconDown: {
    transform: 'rotateZ(270deg) scale(0.85)',
    width: 20,
    height: 20,
    opacity: 0.54,
    paddingRight: 12,
  },
  checkIcon: {
    fill: theme.color.green,
  },
});

export default styles;
